import {
    AbstractPopupMenuProvider,
    PopupMenuProviderType,
} from './AbstractPopupMenuProvider';

class PopupAppendMenuProvider extends AbstractPopupMenuProvider {
    protected getPopupMenuType() {
        return PopupMenuProviderType.Append;
    }
}

export default PopupAppendMenuProvider;
